import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ExamAttrSetting from "./components/ExamAttrSetting.vue";
export default {
  name: "ExamIndex",
  components: {
    ExamAttrSetting: ExamAttrSetting
  },
  data: function data() {
    return {
      visible: false,
      questionType: "专项练习",
      answer_num: 0,
      right_rate: 0,
      right_rate_int: "",
      right_rate_decimal: "",
      showMessage: false
    };
  },
  computed: {
    isLogin: function isLogin() {
      return !!this.$store.state.token;
    }
  },
  // mounted() {
  //   this.$kefu()
  // },
  methods: {
    getData: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var attr_val_id, data, right_rate;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                attr_val_id = this.$refs.attr.getAttrValId();

                if (!this.$store.state.token) {
                  _context.next = 12;
                  break;
                }

                _context.next = 4;
                return this.$http.get("/api/app/special/first", {
                  attr_val_id: attr_val_id
                });

              case 4:
                data = _context.sent;
                this.answer_num = data.answer_num;
                right_rate = data.right_rate.replace("%", "");
                this.right_rate = parseFloat(right_rate);
                this.right_rate_int = right_rate.split(".")[0];
                this.right_rate_decimal = right_rate.split(".")[1] || "";
                _context.next = 14;
                break;

              case 12:
                this.answer_num = "****";
                this.right_rate_int = "**";

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    onAttrCreated: function () {
      var _onAttrCreated = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getData();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onAttrCreated() {
        return _onAttrCreated.apply(this, arguments);
      }

      return onAttrCreated;
    }(),
    beginSpecial: function () {
      var _beginSpecial = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var treeData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$refs.limitModal.checkAnswer(3, "专项练习");

              case 2:
                _context3.next = 4;
                return this.$http.get("/api/app/special/second", {
                  attr_val_id: this.$refs.attr.getAttrValId()
                });

              case 4:
                treeData = _context3.sent;

                if (!(treeData.length == 0)) {
                  _context3.next = 8;
                  break;
                }

                this.showMessage = true;
                return _context3.abrupt("return");

              case 8:
                this.$router.push({
                  name: "ExamPoint"
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function beginSpecial() {
        return _beginSpecial.apply(this, arguments);
      }

      return beginSpecial;
    }(),
    beginPackage: function () {
      var _beginPackage = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$http.get("/api/app/practice/package", {
                  attr_val_id: this.$refs.attr.getAttrValId()
                });

              case 2:
                data = _context4.sent;

                if (!(data.total == 0)) {
                  _context4.next = 6;
                  break;
                }

                this.showMessage = true;
                return _context4.abrupt("return");

              case 6:
                this.$router.push({
                  name: "ExamPackage"
                });

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function beginPackage() {
        return _beginPackage.apply(this, arguments);
      }

      return beginPackage;
    }(),
    //随机练习
    beginRandom: function () {
      var _beginRandom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$refs.limitModal.checkAnswer(1, "随机练习");

              case 2:
                _context5.next = 4;
                return this.$http.post("/api/app/practice/report", {
                  type: 1,
                  // attr_val_id:0
                  attr_val_id: this.$refs.attr.getAttrValId()
                });

              case 4:
                data = _context5.sent;

                if (!(data.length === 0)) {
                  _context5.next = 8;
                  break;
                }

                this.showMessage = true;
                return _context5.abrupt("return");

              case 8:
                this.$router.push({
                  name: "ExamRandomDo",
                  query: {
                    id: data,
                    examType: "随机练习"
                  }
                });

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function beginRandom() {
        return _beginRandom.apply(this, arguments);
      }

      return beginRandom;
    }(),
    // 自由组卷
    beginFreedom: function () {
      var _beginFreedom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this = this;

        var info, quesCount, key, data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.$refs.limitModal.checkAnswer(6, "自由组卷");

              case 2:
                _context6.next = 4;
                return this.$http.get("/api/app/freedom/getQuestionInfo", {
                  source: 3,
                  attr_val_id: this.$refs.attr.getAttrValId()
                });

              case 4:
                info = _context6.sent;
                quesCount = 0;

                for (key in info.question_count_detail) {
                  quesCount += info.question_count_detail[key];
                }

                if (quesCount) {
                  _context6.next = 10;
                  break;
                }

                this.showMessage = true;
                return _context6.abrupt("return");

              case 10:
                _context6.next = 12;
                return this.$http.get("/api/app/freedom/IsExistRemedied");

              case 12:
                data = _context6.sent;

                if (!(data == 3)) {
                  _context6.next = 17;
                  break;
                }

                // 第一次进入
                this.$router.push({
                  name: "ExamFreedomRule",
                  query: {
                    attr_val_id: this.$refs.attr.getAttrValId()
                  }
                });
                _context6.next = 24;
                break;

              case 17:
                if (!(data == 1)) {
                  _context6.next = 21;
                  break;
                }

                // 记住选择
                this.$router.push({
                  name: "ExamFreedomRule",
                  query: {
                    attr_val_id: this.$refs.attr.getAttrValId(),
                    use_rule: 1
                  }
                });
                _context6.next = 24;
                break;

              case 21:
                _context6.next = 23;
                return this.$promiseConfirm("是否使用上次组卷规则", {
                  callback: function callback() {
                    _this.$router.push({
                      name: "ExamFreedomRule",
                      query: {
                        attr_val_id: _this.$refs.attr.getAttrValId()
                      }
                    });
                  }
                });

              case 23:
                this.$router.push({
                  name: "ExamFreedomRule",
                  query: {
                    attr_val_id: this.$refs.attr.getAttrValId(),
                    use_rule: 1
                  }
                });

              case 24:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function beginFreedom() {
        return _beginFreedom.apply(this, arguments);
      }

      return beginFreedom;
    }(),
    onAttrSave: function () {
      var _onAttrSave = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getData();

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onAttrSave() {
        return _onAttrSave.apply(this, arguments);
      }

      return onAttrSave;
    }()
  }
};